import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ScanFace } from 'lucide-react';
import { useLanguage } from '../../i18n/LanguageContext';
export function AnalyzingStep() {
  const {
    t
  } = useLanguage();
  const [messageIndex, setMessageIndex] = useState(0);
  const messages = [t('faceAnalysis.analyzing.step1'), t('faceAnalysis.analyzing.step2'), t('faceAnalysis.analyzing.step3')];
  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex(prev => (prev + 1) % messages.length);
    }, 1100);
    return () => clearInterval(interval);
  }, [messages.length]);
  return <div className="flex flex-col items-center justify-center py-20" data-id="element-180">
      <div className="relative w-32 h-32 mb-8" data-id="element-181">
        {/* Outer pulsing rings */}
        <motion.div animate={{
        scale: [1, 1.5, 1],
        opacity: [0.5, 0, 0.5]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute inset-0 rounded-full border-2 border-brand-copper" data-id="element-182" />
        <motion.div animate={{
        scale: [1, 1.3, 1],
        opacity: [0.8, 0, 0.8]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 0.5
      }} className="absolute inset-2 rounded-full border-2 border-brand-lightCopper" data-id="element-183" />

        {/* Center Icon */}
        <div className="absolute inset-0 flex items-center justify-center bg-white rounded-full shadow-lg shadow-brand-copper/20 z-10" data-id="element-184">
          <ScanFace className="w-12 h-12 text-brand-copper" data-id="element-185" />
        </div>

        {/* Scanning line over icon */}
        <motion.div animate={{
        top: ['10%', '90%', '10%']
      }} transition={{
        duration: 1.5,
        repeat: Infinity,
        ease: 'linear'
      }} className="absolute left-4 right-4 h-0.5 bg-brand-copper shadow-[0_0_8px_#c79268] z-20" data-id="element-186" />
      </div>

      <h3 className="text-2xl font-light text-gray-900 mb-2" data-id="element-187">
        {t('faceAnalysis.analyzing.title')}
      </h3>

      <div className="h-6 overflow-hidden" data-id="element-188">
        <motion.p key={messageIndex} initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: -20,
        opacity: 0
      }} className="text-gray-500 font-medium" data-id="element-189">
          {messages[messageIndex]}
        </motion.p>
      </div>
    </div>;
}